import "./Flights.css";
import React, { useState, useEffect, useRef, MouseEvent, ChangeEvent } from 'react';
import { FaEllipsisH } from "react-icons/fa";
import { BsPlusLg } from "react-icons/bs";
import { RiArrowDropUpLine } from "react-icons/ri";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { GrView } from "react-icons/gr";
import { TbEdit } from "react-icons/tb";
import { AiOutlineDelete } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteFlight,
  getFlightbyId,
  getFlight,
} from "../../../components/Axios/Axios";
import ReactPaginate from "react-paginate";
import AddFlightModal from "../../../components/Modal/AddFlightModal";
import AddFlightManual from "../../../components/Modal/AddFlightManual";
import AddAircraftModal from "../../../components/Modal/AddAircraftModal";
import ViewFlight from "./viewFlight";
import LayoutProvider from "../../../providers/LayoutProvider";
import EditFlight from "./editFlight";
import { Dropdown } from "react-bootstrap";
type EventListenerType = (event: MouseEvent) => void;
function Flights() {
  const [aircraftData, setAircraftData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(0);
  const itemsPerPage = 10; // Number of items to display per page
  const [showNestedList, setShowNestedList] = React.useState(false);
  const [aircraftNestedList, setAircraftNestedList] = React.useState(false);
  const [addFlight, setAddFlight] = React.useState(false);
  const [addAircraft, setAddAircraft] = React.useState(false);
  const [isAutoModalOpen, setIsAutoModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [isManualModalOpen, setIsManualModalOpen] = React.useState(false);
  const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const contextMenuRef = useRef<HTMLDivElement>(null);
  const [selectedFlightData, setSelectedFlightData] = useState<any>([]);
  const [numEntries, setNumEntries] = useState(0);
  const navigate=useNavigate()


  const handleOpenAuto = () => {
    setIsAutoModalOpen(true);
    setIsManualModalOpen(false);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };

  const handleOpenManual = () => {
    setIsAutoModalOpen(false);
    setIsManualModalOpen(true);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };

  const handleOpenEdit = (flightData: any) => {
    setSelectedFlightData(flightData);
    setIsEditModalOpen(true);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };

  const handleCloseAuto = () => {
    setIsAutoModalOpen(false);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };

  const handleCloseManual = () => {
    setIsManualModalOpen(false);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };

  const handleCloseEdit = () => {
    setIsEditModalOpen(false);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };


  const handleAddFlight = () => {
    setAddFlight(true);
    setIsAutoModalOpen(true);

  };

  const handleCloseFlight = () => {
    setAddFlight(false);
  };

  const handleAddAircraft = () => {
    setAddAircraft(true);
  };

  const handleCloseAircraft = () => {
    setAddAircraft(false);
  };

  const handleToggleAircraftList = () => {
    setAircraftNestedList(!aircraftNestedList);
  };

  const handleToggleNestedList = () => {
    setShowNestedList(!showNestedList);
  };

  const handleDelete = async (flightId: string) => {
    try {
      // Make an API request to delete the flight using deleteFlight function
      await deleteFlight(flightId);
      // If deletion is successful, call triggerRefresh to refresh the Flights component
      setRefresh(refresh + 1);
    } catch (error) {
      console.error("Error deleting flight:", error);
    }
  };


  React.useEffect(() => {
    async function fetchData() {
      try {
        const data = await getFlight();
        const data3 = data;
        setAircraftData(data3);
        setNumEntries(data3.length);
        console.log("Fetched data:", data3); // Log the fetched data
      } catch (error) {
        console.error("Error fetching flight data:", error);
      }
    }
    fetchData();
  }, [refresh, numEntries]);



  const totalPages = Math.ceil(aircraftData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const itemsToDisplay = aircraftData.slice(startIndex, endIndex);

  const handlePageChange = ({ selected }: { selected: number }) => {
    setCurrentPage(selected + 1); // Adjust currentPage value to start from 1
  };


  const handleDotClick = (index: any) => {
    setSelectedRow(index === selectedRow ? null : index);
  };


  return (
    <LayoutProvider>
      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h4 className="dashboard_heading">My Flights</h4>
        <h6 className="dashboard_subheading">Dashboard {">"} Flights</h6>
      </section>
      <section className="allflights">
        {/* <h4 className="heading3" style={{ fontWeight: "500" }}>
          All Flights
        </h4> */}
        <section style={{ display: "flex", gap: "15px" }}>
          {/* <button className="filter_btn">
            Filter <RiArrowDropUpLine />
          </button>
          <button className="filter_btn">
            Filter <RiArrowDropUpLine />
          </button>
          <button className="filter_btn">
            Filter <RiArrowDropUpLine />
          </button> */}
          <button className="button heading4" onClick={handleOpenAuto}>
            <BsPlusLg /> Add Flight
          </button>

          {isAutoModalOpen && (
            <AddFlightModal
              open={isAutoModalOpen}
              onCloseFm={handleCloseAuto}
              onOpenManual={handleOpenManual}
            />
          )}

          {isManualModalOpen && (
            <AddFlightManual
              open={isManualModalOpen}
              onCloseFm={handleCloseManual}
              onOpenAuto={handleOpenAuto}
            />
          )}
          <button className="button b_g heading4" style={{ background: "#f69110" }} onClick={handleAddAircraft}>
            <BsPlusLg /> Add Aircraft
          </button>
          <AddAircraftModal open={addAircraft} onClose={handleCloseAircraft} />
        </section>
      </section>
      <div className="div_container" style={{ marginTop: "2%" }}>
        <div className="today_fleets">
          <div className="header_th">
            <div>Date</div>
            <div>Flight</div>
            <div>Aircraft</div>
            <div>Flight No</div>
            <div>Lndgs.</div>
            <div>Day</div>
            <div>Nights</div>
            <div>X-C</div>
            <div>IMC</div>
            <div>Grnd. Sim.</div>
            <div>Dual Rcv.</div>
            <div>SIC</div>
            <div>PIC</div>
            <div>EP</div>
            <div>IP</div>
            <div>Total</div>
            <div>&nbsp;</div>
          </div>
          <div>
            {itemsToDisplay.map((data: any, index: number) => (

              <div
                className="header_td"
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#EFF6FF" : "white",
                }}
              >
                {
                  data.flightDate ? (<div>{data.flightDate.slice(0, 10)}</div>) : (<div className="heading5">-</div>)}
                {data.route && data.route !== " to " ? (
                  <div>
                    {data.route}
                  </div>
                ) : (
                  <div className="heading5">-</div>
                )}
                <div>{data?.aircraft?.model || "-"}</div>
                <div>{data?.flightNumber || "-"}</div>
                <div>{data?.landingsAndApproaches?.totalLandings || 0}</div>
                <div>{data?.times?.day || 0}</div>
                <div>{data?.times?.night || 0}</div>
                <div>{data?.times?.crossCountry || 0}</div>
                <div>{data?.times?.imc?.toFixed(2) || 0}</div>
                <div>{data?.time?.groundSim || 0}</div>
                <div>{data?.times?.dualReceived || 0}</div>
                <div>{data?.times?.sic || 0}</div>
                <div>{data?.times?.pic || 0}</div>
                <div>{data.times?.ep || 0}</div>
                <div>{data?.times?.ip || 0}</div>
                <div>{data?.times?.totalTime || 0}</div>
                <div>
                  <Dropdown >
                    <Dropdown.Toggle id="dropdown-basic" style={{ background: "none", color: "#5b5b5b", border: "none" }}>
                      <FaEllipsisH />
                    </Dropdown.Toggle>
                    <Dropdown.Menu >
                      <Dropdown.Item><Link className="view_link" to={`/logbook/flights/view_flight/${data._id}`}>View</Link></Dropdown.Item>
                      <Dropdown.Item type='button' onClick={() => handleDelete(data._id)}>Delete</Dropdown.Item>
                      <Dropdown.Item  onClick={() => handleOpenEdit(data)}>Edit</Dropdown.Item>
                      {/* <Dropdown.Item href="#/action-3">{row.isActive ? "Deactivate" : "Activate"}</Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            ))}
          </div>
        </div>
        {isEditModalOpen && (
          <EditFlight
            open={isEditModalOpen}
            onCloseEdit={handleCloseEdit}
            onOpenEdit={handleOpenEdit}
            selectedFlightData={selectedFlightData}
          />
        )}
      </div>
      <div className="pagination-container-one">
        <ReactPaginate
          previousLabel="Prev"
          nextLabel="Next"
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      </div>
    </LayoutProvider>
  );
}
export default Flights;
